<template>
  <div>
    <div id="bg"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>
      <SubHeaderWithSidebar title="Live Q&A" />
      <!-- //header -->
      <Gnb v-if="showGnb" />
      <div id="container" ref="container">
        <section id="contents">
          <div class="qnaWrap list-style2">
            <div class="qnaChoice">
              <ul>
                <li :style="qna.colorStyle" v-bind:key="qna.id" v-for="qna in qnas">
                  <a href="#" @click.prevent="golist(qna)">
                    <div class="num">{{qna.indi}}</div>
                    <h3>{{qna.title}}</h3>
                    <span class="arrow">
                      <img src="@/assets/img/qna_more.png" alt="더보기" />
                    </span>
                  </a>
                </li>
              </ul>
              <ul v-if="qnas.length === 0" class="shareList">
                <li>
                  <div class="dt" style="text-align:center;">
                    <div class="title">등록된 Q&A가 없습니다.</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- qnaWrap -->
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
    </div>
    <!-- //wrap -->
  </div>
</template>

<script>
import SubHeaderWithSidebar from "@/components/SubHeaderWithSidebar";
import Gnb from "@/components/Gnb";
import router from "@/router";
import sideMixin from "@/components/SideMixin";

export default {
  mixins: [sideMixin],
  components: { SubHeaderWithSidebar, Gnb },
  created: function() {
    this.$store.dispatch("loadQnaFullList");
  },

  computed: {
    showGnb: function() {
      return this.$store.getters.getShowGnb;
    },
    qnas: function() {
      let k = this.$store.getters.getQnaList;
      let colors = ["#0099c1", "#2ba19d", "#5cab83"];
      for (var i = 0; i < k.length; i++) {
        let c = i % colors.length;
        k[i].colorStyle = "background:" + colors[c];
        k[i].indi = "0" + (i + 1);
        k[i].indiOnlyNum = i;
      }
      return k;
    }
  },
  methods: {
    golist: function(qna) {
      let colors = ["#0099c1", "#2ba19d", "#5cab83"];
      let _k = qna.indiOnlyNum % 3;
      this.$store.state.qna_bg = colors[_k];
      this.$store.state.qna_logical_index = qna.indi;

      router.push("/qna/list/" + qna.id);
    }
  }
};
</script>
